import { httpV2 } from "@/api/index";

/**
 * Solicita o resultado do modo de fluxo magnético.
 * @param {number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetDiagnostics = function(resultId)
{
	return httpV2.get(`/HydroGeneratingUnitDiagnostic/${resultId}/MagneticFlux`);
};

export default { GetDiagnostics };